import { createUtilityClasses } from './createUtilityClasses';

export const classes = createUtilityClasses(['m', 'mt', 'mb', 'mr', 'ml']);
